import React, { Component } from 'react';

const centre = {
    margin: "auto",
    width: "50%",
};

class Unauthorized extends Component {
    render() {
        return (
            <div className="card">
                <div style={centre}>
                    <h1>Unauthorized!</h1>
                    <p>Please Contact System Administrator!</p>
                    <img src="/unauthorized.gif" alt="unauthorized..." />
                </div>
            </div>

        );
    }
}

export default Unauthorized;